var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 175,
    viewBox: "0 0 176 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.5,
    r: 87,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_370",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 176,
    height: 175
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 87.5,
    r: 87.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.3 121.179C73.99 124.765 74.7689 128.527 77.1529 131.292C80.8769 135.612 87.2449 136.192 92.9409 136.461C96.1679 136.613 99.928 136.533 101.903 133.978C103.362 132.093 103.308 129.5 103.548 127.128C104.313 119.576 108.596 112.925 111.72 106.008C119.726 88.2829 120.158 67.2839 112.891 49.2439C111.879 46.7339 110.672 44.2049 108.645 42.4109C106.365 40.3949 103.3 39.5289 100.302 39.0069C86.692 36.6339 60.4409 40.0269 61.3029 58.2649C62.2739 78.8159 69.408 100.955 73.3 121.179Z",
    fill: "#FFE7FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.764 200.626C135.27 200.696 137.975 200.709 140.016 199.255C143.473 196.793 143.229 191.667 142.553 187.477C140.198 172.881 136.188 157.078 124.243 148.366C115.035 141.651 102.909 140.591 91.5213 140.992C82.3933 141.314 73.3073 142.419 64.2853 143.842C58.3983 144.77 52.2563 145.956 47.6183 149.7C41.1973 154.883 39.1653 163.644 37.5273 171.732C36.2373 178.097 30.1073 192.285 36.1293 197.036C41.6923 201.425 59.8633 198.575 66.8333 198.771C88.8103 199.389 110.787 199.998 132.764 200.626Z",
    fill: "#6987FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5912 188.839C77.5772 193.148 79.0382 197.564 82.2112 200.643C85.3832 203.721 90.6992 204.979 94.2952 202.408C98.6262 199.312 98.3682 192.969 98.3772 187.646C98.3862 181.815 99.2612 175.987 100.962 170.41C103.45 162.256 107.715 154.537 108.503 146.049C108.769 143.191 108.44 139.905 106.179 138.138C104.805 137.064 102.989 136.783 101.257 136.576C91.6882 135.433 75.0032 132.564 71.9542 145.033C70.4962 150.993 73.0142 159.217 73.5602 165.265C74.2722 173.162 74.8182 181.088 76.5912 188.839Z",
    fill: "#DBC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1171 89.6279C70.6871 89.6519 68.2551 89.6759 65.8251 89.6999C65.1261 89.7059 64.3331 89.7549 63.8851 90.2919C63.3341 90.9519 63.6611 92.0259 64.3351 92.5599C65.0101 93.0929 65.9061 93.2289 66.7581 93.3459C67.8541 93.4969 68.9501 93.6479 70.0451 93.7989C71.5891 94.0119 73.3421 94.1679 74.5321 93.1619C75.7231 92.1559 75.2751 89.6059 73.7211 89.7239",
    fill: "#F03FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.299 90.8477C104.868 90.8717 102.438 90.8947 100.007 90.9187C99.3082 90.9257 98.5162 90.9747 98.0672 91.5117C97.5172 92.1717 97.8432 93.2457 98.5182 93.7797C99.1912 94.3127 100.088 94.4487 100.939 94.5657C102.035 94.7167 103.132 94.8677 104.228 95.0187C105.771 95.2307 107.523 95.3877 108.714 94.3817C109.904 93.3757 109.457 90.8257 107.903 90.9447",
    fill: "#F03FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8857 72.9367C69.5647 72.1217 70.4297 71.5527 71.3317 71.0887C72.2407 70.6347 73.2147 70.3207 74.2167 70.1377C76.2057 69.7787 78.3797 69.9277 80.1867 71.0067C79.1617 71.2947 78.2297 71.4097 77.3047 71.6087L74.5737 72.1047C72.7467 72.4157 70.9577 72.7827 68.8857 72.9367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2979 80.5768C76.2979 82.1918 75.4769 83.4998 74.4629 83.4998C73.4499 83.4998 72.6289 82.1918 72.6289 80.5768C72.6289 78.9618 73.4499 77.6528 74.4629 77.6528C75.4769 77.6528 76.2979 78.9618 76.2979 80.5768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.954 73.2486C106.893 72.9776 105.128 72.5106 103.322 72.0976L100.623 71.4486C99.7103 71.1986 98.7863 71.0306 97.7793 70.6846C99.6453 69.7106 101.823 69.6836 103.789 70.1536C104.778 70.3926 105.733 70.7616 106.615 71.2656C107.489 71.7806 108.321 72.3966 108.954 73.2486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.629 80.5768C101.629 82.1918 102.45 83.4998 103.464 83.4998C104.477 83.4998 105.298 82.1918 105.298 80.5768C105.298 78.9618 104.477 77.6528 103.464 77.6528C102.45 77.6528 101.629 78.9618 101.629 80.5768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6589 78.9209C86.7729 79.1719 85.9599 85.6659 83.8999 89.1379C83.8999 89.1379 83.4479 91.5279 88.0509 92.8269",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0693 99.4517C82.0693 99.4517 90.1563 102.133 96.4243 99.5897",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.86 115.92L74.72 127.96L74.25 132.89L71.29 134.75L54.7 145.15C44.13 151.78 36.68 162.38 34.03 174.57L29 197.7",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9502 115.04L100.37 119.5L101.19 128.09L101.64 132.89L121.19 145.15C131.76 151.78 139.21 162.38 141.86 174.57L146.89 197.7",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68 61.3696C119.73 63.2596 119.74 65.0896 119.71 66.8596C119.71 66.8996 119.72 66.9296 119.72 66.9496C119.72 66.9596 119.72 66.9796 119.71 66.9896C119.38 89.2996 113.44 102.07 106.76 109.37C104.51 111.83 102.18 113.66 99.9505 115.04C99.2105 115.5 98.4805 115.9 97.7705 116.26C92.0805 119.15 87.5205 119.15 87.5205 119.15C86.3705 119.15 85.2605 119.07 84.2005 118.92C81.0905 118.49 78.3305 117.44 75.8605 115.92C74.2505 114.93 72.7705 113.74 71.4205 112.39C62.3605 103.41 58.5005 87.3296 56.7805 75.6096L56.7705 75.5996C56.7005 75.1196 56.6305 74.6396 56.5705 74.1796C55.5705 66.9196 55.3905 61.6496 55.2305 61.3696",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.969 35.6968C135.778 55.7188 143.343 135.45 103.402 133.998L99.9457 115.04C108.815 109.56 119.266 96.7898 119.706 66.9898C119.716 66.9798 119.716 66.9798 119.716 66.9798C119.716 66.9798 119.716 66.9698 119.716 66.9498C119.716 66.9298 119.706 66.8998 119.706 66.8598C119.656 65.9598 118.896 59.9698 108.605 45.4698C108.605 45.4698 95.3357 61.3698 75.8557 61.3698C57.5657 61.3698 56.3457 70.5798 56.5657 74.1798C56.6257 75.0598 56.7657 75.5998 56.7657 75.5998L56.7757 75.6098C58.7557 89.0898 63.5657 108.35 75.8557 115.92L74.2457 132.89L47.6177 149.7C45.2527 129.542 41.6547 103.132 41.8147 70.4218C41.8147 70.4218 40.5947 9.68884 97.7357 15.3758C97.7357 15.3758 111.33 17.7308 113.243 24.1188C113.243 24.1188 127.078 25.7378 129.969 35.6968Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2461 132.89C74.2461 132.89 87.7881 141.66 101.636 132.89",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4834 133.998C72.4834 133.998 87.9584 147.621 103.402 133.998",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.856 197.7C80.856 197.7 80.746 197.19 80.546 196.25C80.316 195.18 79.976 193.56 79.546 191.53C79.226 190.03 78.856 188.29 78.456 186.39C78.136 184.91 77.806 183.33 77.446 181.67C77.096 180.02 76.736 178.3 76.356 176.53C76.036 174.99 75.696 173.41 75.356 171.81C74.996 170.1 74.636 168.38 74.266 166.67C73.936 165.09 73.596 163.51 73.266 161.95C72.896 160.2 72.536 158.48 72.186 156.81C71.836 155.19 71.506 153.6 71.186 152.09C69.346 143.33 67.996 136.82 68.036 136.79",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8772 142.529C58.5612 142.727 57.2422 156.37 57.2422 156.37L69.7772 169.737L66.2612 177.853L79.2952 190.346",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3262 197.7C94.3262 197.7 94.4362 197.19 94.6362 196.25C94.8662 195.18 95.2062 193.56 95.6362 191.53C95.9562 190.03 96.3262 188.29 96.7262 186.39C97.0462 184.91 97.3862 183.33 97.7362 181.67C98.0862 180.02 98.4562 178.3 98.8262 176.53C99.1562 174.99 99.4862 173.41 99.8262 171.81C100.186 170.1 100.546 168.38 100.916 166.67C101.246 165.09 101.586 163.51 101.906 161.95C102.276 160.2 102.646 158.48 102.996 156.81C103.336 155.19 103.676 153.6 103.986 152.09C105.836 143.33 107.186 136.82 107.146 136.79",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.305 142.529C116.621 142.727 117.94 156.37 117.94 156.37L105.405 169.737L108.921 177.853L95.8867 190.346",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.986 152.09C103.676 153.6 103.336 155.19 102.996 156.81H72.1855C71.8355 155.19 71.5055 153.6 71.1855 152.09H103.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.906 161.95C101.586 163.51 101.246 165.09 100.916 166.67H74.2656C73.9356 165.09 73.5956 163.51 73.2656 161.95H101.906Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8264 171.81C99.4864 173.41 99.1564 174.99 98.8264 176.53H76.3564C76.0364 174.99 75.6964 173.41 75.3564 171.81H99.8264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0694 39.3787C83.0694 45.7947 76.7354 50.9967 68.9214 50.9967C61.1074 50.9967 54.7734 45.7947 54.7734 39.3787C54.7734 32.9627 61.1074 27.7607 68.9214 27.7607C76.7354 27.7607 83.0694 32.9627 83.0694 39.3787Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.176 39.3787C120.176 45.7947 113.841 50.9967 106.027 50.9967C98.2139 50.9967 91.8789 45.7947 91.8789 39.3787C91.8789 32.9627 98.2139 27.7607 106.027 27.7607C113.841 27.7607 120.176 32.9627 120.176 39.3787Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0693 39.3788C83.0693 39.3788 87.1663 35.7238 91.8793 39.3788",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 119.5C92.5197 122.16 80.3397 126.13 74.7197 127.96L75.8597 115.92C78.3297 117.44 81.0897 118.49 84.1997 118.92C85.2597 119.07 86.3697 119.15 87.5197 119.15C87.5197 119.15 92.0797 119.15 97.7697 116.26C98.4797 115.9 99.2097 115.5 99.9497 115.04L100.37 119.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam3);
export default __webpack_public_path__ + "static/media/team3.7a234ef6bb44cd6f0075957b5564c794.svg";
export { ForwardRef as ReactComponent };